/* import __COLOCATED_TEMPLATE__ from './appointments-location-selector.hbs'; */
var _dec, _dec2, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action } from '@ember/object';
import { readOnly } from '@ember/object/computed';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
let AppointmentsLocationSelectorComponent = (_dec = readOnly('selectedPlan.name'), _dec2 = readOnly('selectedPlan.isFree'), _class = class AppointmentsLocationSelectorComponent extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "appointmentsSubscription", _descriptor, this);
    _initializerDefineProperty(this, "dataApi", _descriptor2, this);
    _initializerDefineProperty(this, "formatter", _descriptor3, this);
    _initializerDefineProperty(this, "intl", _descriptor4, this);
    _initializerDefineProperty(this, "planName", _descriptor5, this);
    _initializerDefineProperty(this, "shouldSelectOneLocation", _descriptor6, this);
    _initializerDefineProperty(this, "noLocationSelected", _descriptor7, this);
    _initializerDefineProperty(this, "selectedLocations", _descriptor8, this);
    this.dataApi.track('Page', {
      platform: 'web',
      page_name: '/appointments/onboarding/locations',
      plan_token: this.selectedPlan.token
    });
  }
  get formattedPlanPrice() {
    return this.formatter.currency(this.selectedPlan.priceInCent, this.selectedPlan.currencyCode);
  }
  get locations() {
    return this.args.locations ?? []; // each has a token and a nickname
  }
  get selectedPlan() {
    return this.args.selectedPlan ?? null;
  }
  get subtitle() {
    return this.shouldSelectOneLocation ? this.intl.t('apptsUpsell.subscription.locationSelector.subtitle.singleLocation') : this.intl.t('apptsUpsell.subscription.locationSelector.subtitle.multiLocation', {
      planName: this.planName,
      formattedPlanPrice: this.formattedPlanPrice
    });
  }
  onSelectMultipleLocations(token) {
    const indexOfToken = this.selectedLocations.indexOf(token);
    if (indexOfToken < 0) {
      this.selectedLocations.push(token);
    } else {
      this.selectedLocations.splice(indexOfToken, 1);
    }
    this.dataApi.track('Click Page', {
      platform: 'web',
      page_name: '/appointments/onboarding/locations',
      item_clicked: token,
      plan_token: this.selectedPlan.token
    });
    this.noLocationSelected = this.selectedLocations.length === 0;
  }
  onSelectSingleLocation(token) {
    this.selectedLocations.splice(0, 1);
    this.selectedLocations.push(token);
    this.noLocationSelected = false;
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "appointmentsSubscription", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "dataApi", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "formatter", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "planName", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "shouldSelectOneLocation", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "noLocationSelected", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return true;
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "selectedLocations", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _applyDecoratedDescriptor(_class.prototype, "onSelectMultipleLocations", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSelectMultipleLocations"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onSelectSingleLocation", [action], Object.getOwnPropertyDescriptor(_class.prototype, "onSelectSingleLocation"), _class.prototype), _class);
export { AppointmentsLocationSelectorComponent as default };